import { IncomingSparkInvitation } from "@greenflagdate/shared";

/**
 * Count of the viewer's inviters per spark, derived from their incoming
 * invitations.
 *
 * The server excludes inviters from each spark's `attendingLikedCount` so
 * EventV2 can lead with "{name} invited you" and then "N other sparks
 * attending" without double-counting the inviter. Surfaces that do NOT render
 * the inviter separately — the Events-tab cards and the featured
 * UpcomingEligibleWidget — must add this count back, or an invited user sees an
 * undercount, and the chip vanishes entirely when the inviter was the only
 * liked attendee (count 0 → EventCard hides it). Add it per-surface only; never
 * fold it back into store.upcomingSparks, or EventV2 would double-count again.
 */
export function inviterCountBySpark(
  invitations: IncomingSparkInvitation[] | undefined
): Map<number, number> {
  const counts = new Map<number, number>();
  for (const inv of invitations ?? []) {
    counts.set(inv.event.sparkId, (counts.get(inv.event.sparkId) ?? 0) + 1);
  }
  return counts;
}
